import RootStore from './RootStore';

const stores = {
    RootStore
};

export default stores;



// WEBPACK FOOTER //
// ./src/stores/index.js